import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import { SET_SHIP_TO_ADDRESS_DETAILS } from '../action/types';

const initialState = {
    gridData: [],
};

const reportUsageShippingDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_SHIP_TO_ADDRESS_DETAILS:
            return {
                ...state,
                gridData: action.payload,
            };
        default: {
            return { ...state };
        }
    }
};

export default persistReducer(
    {
        key: 'reportUsageShippingDetailsKey',
        storage: storage,
    },
    reportUsageShippingDetailsReducer
);
